export const cwcComponent = {
  props: {
    border: {
      type: Boolean,
      default: false
    }
  }, // props
  data () {
    return {
      cmptStyle: {
        border: this.border ? 'solid' : 'none',
        textAlign: 'left'
      }
    }
  } // data
}
